export default {
  setSeatObj ({ commit }, payload) {
    commit('saveSeatObj', payload)
  },
}